import { Button, Divider, Drawer, Fab, List, ListItem, ListItemIcon, ListItemText, Grid, Paper, Typography, useMediaQuery } from '@material-ui/core'
import { createMuiTheme, makeStyles, ThemeProvider } from '@material-ui/core/styles';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import MailIcon from '@material-ui/icons/Mail';
import MenuIcon from '@material-ui/icons/Menu';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import {
  useParams,
} from "react-router-dom";
import clsx from 'clsx';
import React, { useEffect, useState } from 'react'
import Iframe from 'react-iframe'
import pointcloudMetadata from '../studentData';
import {useHistory} from 'react-router-dom';
import logo from '../static/logo.png'; // Tell webpack this JS file uses this image
// import logo from '../logo.svg'; // Tell webpack this JS file uses this image

const theme = createMuiTheme(
  {
    palette: {
      type: 'dark',
      secondary: {
        main: '#ffffff'
      }
    }
  }
);

// theme.spacing(2) // = 8 * 2

const useStyles = makeStyles({
  list: {
    width: 250,
  },
  logo: {
    position: 'fixed', 
    zIndex: 2, 
    margin: '20px',
    height: '20%',
    maxHeight: '100px'
  },
  logoImg: {
    maxHeight: '100%',
    height: '100%'
  },
  header: {
    fontFamily: 'Decima',
    textAlign: 'center',
    padding: '10px',
    userSelect: 'none'
  },
  fullList: {
    width: 'auto',
  },
  root: {
    flexGrow: 1,
  },
  paper: {
    fontFamily: 'Gotham',
    padding: theme.spacing(2),
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: '8px',
    },
    color: theme.palette.text.secondary,
    cursor: 'pointer',
    background: 'black',
    '&:hover': {
       background: "#ffffff",
       color: '#000000'
    },
    '&:active': {
      // background: "#ffffff",
      background: theme.palette.background.paper,
      color: theme.palette.text.secondary,
   },
  },
  paperRoot: {
    width: '75%',
    left: '12.5%',
    padding: '10px'
  },
  fabBtn: {
    position: 'fixed',
    bottom: '1%',
    right: '1%',
  },
  studentsBtn: {
    margin: '10px',

  },
  backBtn: {
    margin: '10px',
  }
});

export default function PointCloudPage () {
    const classes = useStyles();
    const history = useHistory();
    const matches = useMediaQuery(theme.breakpoints.down('sm'));
    const [isOpen, setOpen] = useState(false);
    const [isIframeLoaded, setIframeLoaded] = useState(false);
    const [state, setState] = React.useState({
      top: false,
      left: false,
      bottom: false,
      right: false,
    });

    const { id } = useParams();
    const url = pointcloudMetadata.units.filter((meta) => meta.id == id)[0].url;
    const unitName = pointcloudMetadata.units.filter((meta) => meta.id == id)[0].name;
    const studentData = pointcloudMetadata.units.filter((meta) => meta.id == id)[0].students;
    const selectedAnchor = 'top';
    
    useEffect(() => {
      setIframeLoaded(false);
      window.addEventListener('message', (e) => {
        console.log(e.data);
        if (e.data === 'finishedLoading') {
          setOpen(true);
        } else if (e.data === 'windowLoaded') {
          if (!isIframeLoaded) setIframeLoaded(true);
        }
      });

    }, [])
  
    const toggleDrawer = (anchor: string, open: boolean) => (event: object) => {
      // @ts-ignore
      if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
        return;
      }
  
      setState({ ...state, [anchor]: open });
    };

    const creditsList = (anchor) => (
      <div
        className={clsx(classes.list, {
          [classes.fullList]: anchor === 'top' || anchor === 'bottom',
        })}
        role="presentation"
        // onClick={toggleDrawer(anchor, false)}
        onKeyDown={toggleDrawer(anchor, false)}
      >
        <Grid
          container
          spacing={3}
          wrap='wrap'
          style={{
            padding: '10px',
            overflowX: 'hidden'
          }}
        >
          {
            // @ts-ignore
            studentData.map((student) => { 
              console.log(student);     
              return (
                <Grid 
                  key={student.name} 
                  item 
                  xs={4}
                  style={{margin: '0'}}
                  onClick={() => {
                    if (!(student.url.length > 0)) return;
                    window.open(student.url, "_blank");
                  }}
                >
                  <Paper
                    className={classes.paper}
                  >
                    {student.name}
                  </Paper>
                </Grid>)
              }
            )
          }
        </Grid>
      </div>
    );

    // const buttons = (anchor) => (
    //   ['left', 'right', 'top', 'bottom'].map((anchor) => (
    //     <React.Fragment key={anchor}>
    //       <Button onClick={toggleDrawer(anchor, true)}>{anchor}</Button>
    //       {/*@ts-ignore */}
    //       <Drawer anchor={anchor} open={state[anchor]} onClose={toggleDrawer(anchor, false)}>
    //         {/* {list(anchor)} */}
    //         {creditsList(anchor)}
    //       </Drawer>
    //     </React.Fragment>
    //   ))
    // )

    // const DrawerComponent = () => {
    //   return (
    //     <div className={classes.root}>
    //       <Drawer  
    //         anchor={selectedAnchor} 
    //         open={state[selectedAnchor]} 
    //         onClose={toggleDrawer(selectedAnchor, false)}
    //       >
    //         {/* {list(anchor)} */}
    //         {creditsList(selectedAnchor)}
    //       </Drawer>
    //     </div>
    //   )
    // }

    const goBack = () => {
      history.push('/');
    }

    return (
      <ThemeProvider theme={theme}>
        <div style={{height: '100vh', width: '100wh'}}>
          {
            (isOpen) ?
            <div className={classes.logo}>
              <img className={classes.logoImg} src={logo} alt="Logo" />
            </div> 
            : null
          }     
          <div className={classes.root}>
            <Drawer 
              anchor={selectedAnchor} 
              open={state[selectedAnchor]} 
              onClose={toggleDrawer(selectedAnchor, false)}
              classes={{
                paper: classes.paperRoot, // class name, e.g. `classes-nesting-root-x`
              }}
            >
              <Typography 
                className={classes.header}
                variant={matches ? 'h4' : 'h2'}>
                {unitName}
              </Typography>
              <Divider variant='middle' />
              {/* {list(anchor)} */}
              {creditsList(selectedAnchor)}
            </Drawer>
          </div>
          <Iframe 
            url={url}
            width={(isIframeLoaded) ? '100%' : '0%'}
            height={(isIframeLoaded) ? '100%' : '0%'}
            id="pointcloud-view"
            display='block'
            position="absolute"
            frameBorder={0}
          />
          {
            (isOpen) ? 
            <div className={classes.fabBtn}>
              <Fab 
                color="secondary" 
                aria-label="students"
                className={classes.studentsBtn}
                onClick={toggleDrawer(selectedAnchor, true)}
              >
                <MenuIcon />
              </Fab>
              <Fab 
                color="secondary" 
                aria-label="back"
                className={classes.backBtn}
                onClick={goBack}
              >
                <ArrowBackIcon />
              </Fab>
            </div>
            : null
          }
        </div>
      </ThemeProvider>

    )
}
